import React, { useEffect, useState } from 'react';
import { useGoogleLogin } from '@react-oauth/google';
import { LoginPageImg } from '../../static/constant/imgConstants';
import { FaApple } from 'react-icons/fa';
import { useNavigate } from 'react-router';
import { useToast } from '../../hooks/useToast';
import { useDispatch, useSelector } from 'react-redux';
import PublicHeader from '../../components/utility/PublicHeader/PublicHeader';
import DropdownWithSearch from '../../components/common/DropdownWithSearch/DropdownWithSearch';
import { sendOtpToCreateUser, sendOtpToCreateUserReset } from "../../store/authStore/actions/authActions/sendOtpToCreateUserActions";
import { getAllCountry } from "../../store/publicStore/actions/publicActions/getAllCountryActions";
import { setUserType } from '../../store/publicStore/actions/utilsActions/utilsActions';
import { getUserInfo, getUserInfoReset } from '../../store/authStore/actions/authActions/getUserInfoActions';
import { useLocation } from "react-router-dom";
import { sendOtpToCreateAgency, sendOtpToCreateAgencyReset } from '../../store/authStore/actions/authActions/sendOtpToCreateAgencyActions';
import { appleUserLogin, appleUserLoginReset } from '../../store/authStore/actions/authActions/appleUserLoginActions';
import { googleUserLogin, googleUserLoginReset } from '../../store/authStore/actions/authActions/googleUserLoginActions';
import VerifyPopup from '../../components/main/VerifyPopup/VerifyPopup';

const Registration = (props) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const Toast = useToast();


    const sendOtpToCreateUserReducer = useSelector(state => state.sendOtpToCreateUserReducer);
    const getAllCountryReducer = useSelector(state => state.getAllCountryReducer);
    const utilReducers = useSelector(state => state.utilReducers);
    const googleUserLoginReducer = useSelector(state => state.googleUserLoginReducer);
    const getUserInfoReducer = useSelector(state => state.getUserInfoReducer);
    const sendOtpToCreateAgencyReducer = useSelector(state => state.sendOtpToCreateAgencyReducer);

    const [loginType, setLoginType] = useState(props.loginType);//default value is "BRAND"
    const [loginDailog1, setLoginDailog1] = useState(props.loginDailog1);
    const [countryCode, setCountryCode] = useState(null); // State for country code and phone number
    const [phoneNumber, setPhoneNumber] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [referredBy, setReferredBy] = useState('');
    const [errors, setErrors] = useState({});
    const [popupMessage, setPopupMessage] = useState(false);

    const googleLogin = useGoogleLogin({
        onSuccess: async tokenResponse => {
            try {
                if (tokenResponse) {
                    dispatch(setUserType(loginType));
                    dispatch(googleUserLogin({
                        token: tokenResponse.access_token,
                        userType: loginType, //BRAND, INFLUENCER, AGENCY
                    }));
                }
            } catch (error) {
                console.error('Error fetching Google user info:', error);
            }
        },
        onError: errorResponse => console.log('Google Login Error', errorResponse),
    });

    const handleAppleLogin = async () => {
        if (!window.AppleID) {
            Toast('Apple Sign In is not available. Please try again.', 'error');
            return;
        }
        try {
            dispatch(setUserType(loginType));
            const response = await window.AppleID.auth.signIn();
            const { code, id_token } = response.authorization;
            const firstName = response.user?.name?.firstName || "";
            const lastName = response.user?.name?.lastName || "";

            dispatch(appleUserLogin({
                code,
                idToken: id_token,
                userType: loginType,
                firstName,
                lastName
            }));
        } catch (error) {
            if (error?.error !== 'user_cancelled_authorize') {
                console.error('Apple Sign In error:', error);
                Toast('Apple Sign In failed. Please try again.', 'error');
            }
        }
    };

    const validateForm = (data) => {
        let formErrors = {};

        // Name validation: letters, spaces, hyphens, apostrophes; 2-50 chars; must start with a letter
        const nameRegex = /^[A-Za-z][A-Za-z\s'-]{1,49}$/;

        // Validate First Name
        if (!data.firstName || !data.firstName.trim()) {
            formErrors.firstName = 'First name is required';
        } else if (!nameRegex.test(data.firstName.trim())) {
            formErrors.firstName = 'First name should be 2-50 letters and may include spaces, hyphens, or apostrophes';
        }

        // Validate Last Name
        if (!data.lastName || !data.lastName.trim()) {
            formErrors.lastName = 'Last name is required';
        } else if (!nameRegex.test(data.lastName.trim())) {
            formErrors.lastName = 'Last name should be 2-50 letters and may include spaces, hyphens, or apostrophes';
        }

        // Validate Email
        const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
        if (!data.email || !data.email.trim()) {
            formErrors.email = 'Email is required';
        } else if (!emailRegex.test(data.email.trim())) {
            formErrors.email = 'Enter a valid email address';
        }

        // Validate Country selection
        // if (!data.countryId) {
        //     formErrors.countryId = 'Please select a country code';
        // }

        // Validate Phone Number: 10 digits, not all same digits
        const onlyDigits = (data.phoneNumber || '').replace(/\D/g, '');
        if (!onlyDigits) {
            formErrors.phoneNumber = 'Phone number is required';
        } else if (!/^\d{10}$/.test(onlyDigits)) {
            formErrors.phoneNumber = 'Enter a valid 10-digit phone number';
        } else if (/^(\d)\1{9}$/.test(onlyDigits)) {
            formErrors.phoneNumber = 'Phone number cannot be all the same digit';
        }

        return formErrors;
    };

    const handleRegister = (e) => {
        e.preventDefault();

        const sanitizedFirstName = firstName.trim();
        const sanitizedLastName = lastName.trim();
        const sanitizedEmail = email.trim();
        const sanitizedPhone = phoneNumber.replace(/\D/g, '').slice(0, 10);

        const formData = {
            firstName: sanitizedFirstName,
            lastName: sanitizedLastName,
            email: sanitizedEmail,
            phoneNumber: sanitizedPhone,
            countryId: countryCode?.countryId || null,
        };

        // Log form data for debugging
        console.log("Form Data:", formData);

        const formErrors = validateForm(formData);
        if (Object.keys(formErrors).length > 0) {
            setErrors(formErrors);
        } else {
            setErrors({});
            // Log the dispatch action for debugging
            console.log("Dispatching sendOtpToCreateUser with data:", {
                "firstName": formData.firstName,
                "lastName": formData.lastName,
                "email": formData.email,
                "countryId": countryCode?.countryId ? countryCode.countryId : 1,
                "phoneNumber": formData.phoneNumber,
                "userType": loginType
            });
            // if (loginType === "BRAND" || loginType === "INFLUENCER") {
            dispatch(sendOtpToCreateUser({
                "firstName": formData.firstName,
                "lastName": formData.lastName,
                "email": formData.email,
                "countryId": countryCode?.countryId || 1,
                "phoneNumber": formData.phoneNumber,
                "userType": loginType,
                "referredBy": referredBy.trim() || null
            }));
        }
    };

    useEffect(() => {
        if (sendOtpToCreateUserReducer.status === 200) {
            Toast(sendOtpToCreateUserReducer.message, 'success');
            dispatch(sendOtpToCreateUserReset());
            navigate(`/verifyOtp/${loginType}`);
        } else if (sendOtpToCreateUserReducer.status === 403) {
            Toast(sendOtpToCreateUserReducer.message, 'error');
            dispatch(sendOtpToCreateUserReset());
        } else if (sendOtpToCreateUserReducer.status === 302) {
            Toast(sendOtpToCreateUserReducer.message, 'error');
            dispatch(sendOtpToCreateUserReset());
        } else if (sendOtpToCreateUserReducer.status) {
            Toast(sendOtpToCreateUserReducer.message, 'info');
            dispatch(sendOtpToCreateUserReset());
        }

        // Log the reducer state for debugging
        console.log('sendOtpToCreateUserReducer:', sendOtpToCreateUserReducer);

    }, [sendOtpToCreateUserReducer, dispatch, navigate, Toast]);

    // useEffect(() => {
    //     if (sendOtpToCreateAgencyReducer.status === 200) {
    //         Toast(sendOtpToCreateAgencyReducer.message, 'success');
    //         dispatch(sendOtpToCreateAgencyReset());
    //         navigate(`/verifyOtp/${loginType}`);
    //     } else if (sendOtpToCreateAgencyReducer.status === 403) {
    //         Toast(sendOtpToCreateAgencyReducer.message, 'error');
    //         dispatch(sendOtpToCreateAgencyReset());
    //     } else if (sendOtpToCreateAgencyReducer.status === 302) {
    //         Toast(sendOtpToCreateAgencyReducer.message, 'error');
    //         dispatch(sendOtpToCreateAgencyReset());
    //     } else if (sendOtpToCreateAgencyReducer.status) {
    //         Toast(sendOtpToCreateAgencyReducer.message, 'info');
    //         dispatch(sendOtpToCreateAgencyReset());
    //     }
    //     // Log the reducer state for debugging
    //     console.log('sendOtpToCreateAgencyReducer:', sendOtpToCreateAgencyReducer);

    // }, [sendOtpToCreateAgencyReducer, dispatch, navigate, Toast]);

    useEffect(() => {
        if (googleUserLoginReducer.status === 200) {
            Toast(googleUserLoginReducer.message, 'success');
            dispatch(getUserInfo());
            dispatch(googleUserLoginReset());
        } else if (googleUserLoginReducer.status === 403) {
            Toast(googleUserLoginReducer.message, 'error');
            dispatch(googleUserLoginReset());
        } else if (googleUserLoginReducer.status === 305) {
            setPopupMessage(googleUserLoginReducer.message)
            dispatch(googleUserLoginReset());
        } else if (googleUserLoginReducer.status) {
            Toast(googleUserLoginReducer.message, 'info');
            dispatch(googleUserLoginReset());
        }
    }, [googleUserLoginReducer]);

    const appleUserLoginReducer = useSelector(state => state.appleUserLoginReducer);

    useEffect(() => {
        if (appleUserLoginReducer.status === 200) {
            Toast(appleUserLoginReducer.message, 'success');
            dispatch(getUserInfo());
            dispatch(appleUserLoginReset());
        } else if (appleUserLoginReducer.status === 403) {
            Toast(appleUserLoginReducer.message, 'error');
            dispatch(appleUserLoginReset());
        } else if (appleUserLoginReducer.status === 305) {
            setPopupMessage(appleUserLoginReducer.message)
            dispatch(appleUserLoginReset());
        } else if (appleUserLoginReducer.status) {
            Toast(appleUserLoginReducer.message, 'info');
            dispatch(appleUserLoginReset());
        }
    }, [appleUserLoginReducer]);

    useEffect(() => {
        console.log("getUserInfoReducer :", getUserInfoReducer);

        if (getUserInfoReducer.status === 200) {
            console.log("loginType :", loginType);

            if (getUserInfoReducer?.data?.userType == "BRAND") {
                console.log("loginType Brand :", loginType);
                navigate(`/brand`);
            }
            else if (getUserInfoReducer?.data?.userType == "INFLUENCER") {
                console.log("loginType Influencer :", loginType);
                navigate(`/influencer`);
            }
            else if (getUserInfoReducer?.data?.userType == "AGENCY") {
                console.log("loginType Agency :", loginType);
                navigate(`/agency`);
            }
        } else if (getUserInfoReducer.status === 403) {
            Toast(getUserInfoReducer.message, 'error');
            dispatch(getUserInfoReset());
        } else if (getUserInfoReducer.status) {
            Toast(getUserInfoReducer.message, 'info');
            dispatch(getUserInfoReset());
        }
    }, [getUserInfoReducer]);


    useEffect(() => {
        dispatch(getAllCountry())
    }, [])

    return (
        <div className='flex flex-col lg:flex-row items-center lg:items-start w-full h-auto min-h-screen overflow-visible'>
            <VerifyPopup message={popupMessage} isOpen={popupMessage} modalAction={() => navigate('/')} type="warning" />
            <div className='flex flex-col justify-center lg:justify-start items-center w-full lg:w-[58%] min-h-max xl:h-full px-[4.8rem] py-[3rem] !overflow-visible'>
                <PublicHeader />
                <div className='flex flex-grow flex-col justify-between items-center gap-auto mt-[2rem] lg:gap-[0] xl:gap-[1rem] text-[1.6rem] w-[90%] md:w-[60%] max-h-min xl:min-h-max md:mt-[1rem] !overflow-visible'>
                    <div className='login-nav flex justify-between items-center w-full '>
                        <h4
                            className={`text-[1.8rem] inter-font font-[600] cursor-pointer ${loginType === "BRAND" ? 'text-green-600 border-b-2 border-green-600' : 'text-gray-500'}`}
                            onClick={() => { navigate('/registration/brand'); setLoginType("BRAND"); setLoginDailog1('Unleash Brand, Forge Connections.') }}
                        >
                            Brand
                        </h4>
                        <h4
                            className={`text-[1.8rem] inter-font font-[600] cursor-pointer ${loginType === "INFLUENCER" ? 'text-green-600 border-b-2 border-green-600' : 'text-gray-500'}`}
                            onClick={() => { navigate('/registration/influencer'); setLoginType("INFLUENCER"); setLoginDailog1('Unleash Influencer, Forge Connections.') }}
                        >
                            Influencer
                        </h4>
                        <h4
                            className={`text-[1.8rem] inter-font font-[600] cursor-pointer ${loginType === "AGENCY" ? 'text-green-600 border-b-2 border-green-600' : 'text-gray-500'}`}
                            onClick={() => { navigate('/registration/agency'); setLoginType("AGENCY"); setLoginDailog1('Unleash Agency, Forge Connections.') }}
                        >
                            Agency
                        </h4>
                    </div>
                    <div className='flex flex-col items-start w-full my-[2rem] lg:my-auto 2xl:my-[2rem] '>
                        <h2 className="text-[1.6rem] inter-font font-[500] text-[#9B9DA1]">{loginDailog1}</h2>
                        <p className="text-[1.6rem] inter-font font-[400]">
                            Please provide below details to secure your verified PaidPromo account.
                        </p>
                    </div>
                    <form onSubmit={handleRegister} className='flex flex-wrap justify-between gap-2 items-center w-full !overflow-visible'>
                        <div className='w-full flex justify-between'>
                            <div className={`w-[48%] mb-[1rem]`}>
                                <label className="text-[1.6rem] roboto-thin font-[400] text-[#111729]">First Name</label>
                                <input
                                    type="text"
                                    name="firstName"
                                    placeholder="First Name"
                                    value={firstName}
                                    onChange={(e) => {
                                        // Allow letters, spaces, hyphens, apostrophes
                                        const val = e.target.value.replace(/[^A-Za-z\s'-]/g, '');
                                        setFirstName(val);
                                        if (errors.firstName) setErrors(prev => ({ ...prev, firstName: undefined }));
                                    }}
                                    onBlur={() => setErrors(prev => ({ ...prev, ...validateForm({ firstName, lastName, email, phoneNumber, countryId: countryCode?.countryId }) }))}
                                    className={`w-full px-[1.6rem] roboto-thin  font-[400] py-[.8rem] bg-[#F3F9FA] border rounded-[1.2rem] focus:outline-none ${errors.firstName ? 'border-red-500' : 'border-gray-300'}`}
                                />
                                {errors.firstName && <p className="text-right text-red-500 text-[1.4rem]">{errors.firstName}</p>}
                            </div>
                            <div className={`w-[48%] mb-[1rem]`}>
                                <label className="text-[1.6rem] roboto-thin  font-[400] text-[#111729]">Last Name</label>
                                <input
                                    type="text"
                                    name="lastName"
                                    placeholder="Last Name"
                                    value={lastName}
                                    onChange={(e) => {
                                        const val = e.target.value.replace(/[^A-Za-z\s'-]/g, '');
                                        setLastName(val);
                                        if (errors.lastName) setErrors(prev => ({ ...prev, lastName: undefined }));
                                    }}
                                    onBlur={() => setErrors(prev => ({ ...prev, ...validateForm({ firstName, lastName, email, phoneNumber, countryId: countryCode?.countryId }) }))}
                                    className={`w-full px-[1.6rem] py-[.8rem] roboto-thin  font-[400] bg-[#F3F9FA] border rounded-[1.2rem] focus:outline-none ${errors.lastName ? 'border-red-500' : 'border-gray-300'}`}
                                />
                                {errors.lastName && <p className="text-right text-red-500 text-[1.4rem]">{errors.lastName}</p>}
                            </div>
                        </div>
                        <div className={`w-full mb-[1rem]`}>
                            <label className="text-[1.6rem] roboto-thin  font-[400] text-[#111729]">Email ID</label>
                            <input
                                type="email"
                                name="email"
                                placeholder="Email"
                                value={email}
                                onChange={(e) => {
                                    setEmail(e.target.value.trimStart());
                                    if (errors.email) setErrors(prev => ({ ...prev, email: undefined }));
                                }}
                                onBlur={() => setErrors(prev => ({ ...prev, ...validateForm({ firstName, lastName, email, phoneNumber, countryId: countryCode?.countryId }) }))}
                                className={`w-full px-[1.6rem] roboto-thin  font-[400] py-[.8rem] bg-[#F3F9FA] border rounded-[1.2rem] focus:outline-none ${errors.email ? 'border-red-500' : 'border-gray-300'}`}
                            />
                            {errors.email && <p className="text-right text-red-500 text-[1.4rem]">{errors.email}</p>}
                        </div>
                        <div className={`w-full mb-[1rem] !overflow-visible`}>
                            <label className="text-[1.6rem] text-[#111729] roboto-thin  font-[400]">Mobile Number</label>
                            <div className={`flex items-center roboto-thin  font-[400] w-full px-[1.6rem] py-[.8rem] bg-[#F3F9FA] border rounded-[1.2rem] focus:outline-none !overflow-visible ${(errors.phoneNumber || errors.countryId) ? 'border-red-500' : 'border-gray-300'}`}>
                                <DropdownWithSearch
                                    options={getAllCountryReducer?.data}
                                    onChange={(val) => {
                                        setCountryCode(val);
                                        // Clear country error on selection
                                        if (errors.countryId) setErrors(prev => ({ ...prev, countryId: undefined }));
                                    }}
                                />
                                <input
                                    type="tel"
                                    placeholder="Phone Number"
                                    inputMode="numeric"
                                    maxLength={10}
                                    value={phoneNumber}
                                    onChange={(e) => {
                                        // Keep only digits and cap to 10
                                        const digits = e.target.value.replace(/\D/g, '').slice(0, 10);
                                        setPhoneNumber(digits);
                                        if (errors.phoneNumber) setErrors(prev => ({ ...prev, phoneNumber: undefined }));
                                    }}
                                    onBlur={() => setErrors(prev => ({ ...prev, ...validateForm({ firstName, lastName, email, phoneNumber, countryId: countryCode?.countryId }) }))}
                                    className="bg-[#F3F9FA] roboto-thin  font-[400] border-none focus:ring-0 outline-none w-[70%] "
                                />
                            </div>
                            {errors.countryId && <p className="text-right text-red-500 text-[1.4rem]">{errors.countryId}</p>}
                            {errors.phoneNumber && <p className="text-right text-red-500 text-[1.4rem]">{errors.phoneNumber}</p>}
                        </div>

                        <div className={`w-full mb-[1rem]`}>
                            <label className="text-[1.6rem] roboto-thin font-[400] text-[#111729]">Referred By (Optional)</label>
                            <input
                                type="text"
                                name="referredBy"
                                placeholder="Enter referrer's name (if any)"
                                value={referredBy}
                                onChange={(e) => {
                                    setReferredBy(e.target.value);
                                }}
                                className="w-full px-[1.6rem] roboto-thin font-[400] py-[.8rem] bg-[#F3F9FA] border border-gray-300 rounded-[1.2rem] focus:outline-none"
                            />
                        </div>

                        <button
                            type="submit"
                            className="w-full bg-[#0D9B50] roboto-thin  font-[400] text-[2rem] text-white py-3 mb-2 mt-[1rem] lg:mt-[2rem] rounded-[1.2rem] hover:bg-green-700"
                        >
                            Create Account
                        </button>
                    </form>
                    <div className=" flex items-center justify-center w-full">
                        <span className="bg-gray-300 h-px w-full"></span>
                        <span className="px-4 mr-4 text-gray-500 inter-font font-[500]">Or</span>
                        <span className="bg-gray-300 h-px w-full"></span>
                    </div>
                    <div className=" w-full">
                        <button
                            onClick={() => googleLogin()}
                            className="w-full flex justify-center items-center roboto-thin  font-[400] py-[.8rem]  bg-[#F3F9FA]/80 text-[1.3rem] rounded-[1.2rem] hover:bg-[#F3F9FA]">
                            <img src={LoginPageImg.google} alt="Google" className="w-[2.8rem] h-[2.8rem] mr-[0.8rem]" />
                            Sign in with Google
                        </button>
                    </div>
                    <div className=" w-full mt-2">
                        <button
                            onClick={() => handleAppleLogin()}
                            className="w-full flex justify-center items-center roboto-thin  font-[400] py-[.8rem]  bg-[#F3F9FA]/80 text-[1.3rem] rounded-[1.2rem] hover:bg-[#F3F9FA]">
                            <FaApple className="w-[2.8rem] h-[2.8rem] mr-[0.8rem]" />
                            Sign in with Apple
                        </button>
                    </div>
                    <div className="text-center inter-font font-[400] text-[1.6rem] text-[#313957] flex lg:mb-[2rem]">
                        Already have an account? <p onClick={() => { navigate('/login', { state: { loginT: loginType, loginDailog: loginDailog1 } }) }} className="text-[#1E4AE9] cursor-pointer">&nbsp;Login</p>
                    </div>
                    <div className="flex justify-center roboto-thin  font-[400] items-center text-[#959CB6] text-center text-[1.4rem] lg:text-[1.6rem] mt-auto">
                        © 2024 ALL RIGHTS RESERVED
                    </div>
                </div>
            </div>
            <div className='flex flex-col justify-center items-center w-[90%] md:w-[60%] lg:w-[42%] min-h-max lg:h-full'>
                <img src={LoginPageImg.loginlogo} alt="" className="w-full h-full" />
            </div>
        </div>
    );
}

export default Registration;
